export const routes = [
  {
    path: '/home',
    component: () => import(/* webpackChunkName: "home" */ './components/Index'),
    name: 'home'
  }
]
